// File: whatsapp.service-config.js
import axios from 'axios';

// Determine if we should use HTTPS for WhatsApp API
const determineWhatsAppApiUrl = () => {
  // Check if we're in production environment and on HTTPS
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && window.location.host === 'crm.sumaroh.com') {
    // Use the HTTPS version of the WhatsApp API
    return 'https://wa.sumaroh.com/api';
  }
  // Otherwise use the wa.sumaroh.com domain
  return 'https://wa.sumaroh.com/api';
};

export const API_BASE_URL = determineWhatsAppApiUrl();
export const AUTH_TOKEN = 'Sumaroh2025@@';
export const DEFAULT_SESSION = 'Sumaroh';

export const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'X-Api-Key': AUTH_TOKEN,
    'Content-Type': 'application/json'
  }
});